/* eslint-disable react/no-unescaped-entities */
import { Box, Divider, Flex, Typography } from '@ergolabs/ui-kit';
import React, { FC } from 'react';

import { useIdoInfo } from '../../common/hooks/useIdoInfo';

const RoundInfo: FC = () => {
  const idoInfo = useIdoInfo();

  return (
    <Box padding={4} borderRadius="l">
      <Flex col>
        <Flex.Item marginBottom={4}>
          <Typography.Title level={3}>Round guidelines</Typography.Title>
        </Flex.Item>
        <Flex.Item marginBottom={4}>
          <Typography.Title level={4}>How does this work?</Typography.Title>
          <Typography.Paragraph>
            This IDO platform is powered by open-source ergopad smart contracts,
            and operates in a similar manner. Each round is divided into two
            phases: the <b>whitelist phase</b> and the <b>contribution phase</b>
            .
          </Typography.Paragraph>
          <Typography.Paragraph>
            • During the <b>whitelist phase</b>, users are required to commit to
            purchasing tokens in the future. They receive whitelist tokens as a
            representation of their commitment.
          </Typography.Paragraph>
          <Typography.Paragraph>
            • During the <b>contribution phase</b>, users can use ERG or SigUSD
            to purchase SPF tokens. The maximum purchase amount is equal to the
            number of whitelist tokens the user has.
          </Typography.Paragraph>
        </Flex.Item>
        <Flex.Item marginBottom={4}>
          <Typography.Title level={4}>
            Who is eligible for participation in the “Community round”?
          </Typography.Title>
          <Typography.Paragraph>
            In order to participate in the Community round, your wallet address
            must be present in the 'Spectrum Finance community snapshot' taken
            on January 16th, 2023 at 12:00:00 UTC. This snapshot includes all
            wallet addresses that have had any interaction with the Ergo side of
            the Spectrum Finance protocol, whether through swapping or
            adding/removing liquidity.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Additionally, addresses who have staked at least 12,500 ergopad
            tokens in the Ergopad staking protocol are also welcome to
            participate. These users will be able to claim 20% of the total
            allocation of the round. The snapshot will be taken on January 22,
            2023 at 17:00:00 UTC.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The interface will automatically detect if you are eligible to
            participate in the Community round.
          </Typography.Paragraph>
        </Flex.Item>
        <Flex.Item marginBottom={4}>
          <Typography.Title level={4}>
            Who is eligible for participation in the “Public round”?
          </Typography.Title>
          <Typography.Paragraph>
            Anyone who has ergo address
          </Typography.Paragraph>
        </Flex.Item>
        <Flex.Item marginBottom={4}>
          <Typography.Title level={4}>How to claim my SPF?</Typography.Title>
          <Typography.Body>
            When all IDO rounds are over, this page will change its view and you
            can claim your tokens here.
          </Typography.Body>
        </Flex.Item>

        <Divider />

        <Flex.Item marginTop={4}>
          <Typography.Body strong>
            Note that to be eligible for the whitelist, you must complete the
            Know-Your-Customer (KYC) process. Unfortunately, due to regulatory
            restrictions, residents of the following countries are prohibited
            from participating in the IDO: Afghanistan, Albania, Algeria,
            Australia, Bangladesh, Barbados, Belarus, Bolivia, Burkina Faso,
            Cambodia, Canada, Cayman Islands, Congo (Democratic Republic),
            Democratic People’s Republic of Korea (DPRK), Ecuador, Egypt,
            Eritrea, Haiti, Iran, Iraq, Japan, Jordan, Lebanon, Mali, Morocco,
            Myanmar, Nepal, Nigeria, Panama, Philippines, Qatar, Russian
            Federation, Senegal, Somalia, Sudan, Syria, Tunisia, Ukraine, United
            States of America (USA), Yemen, Zimbabwe
          </Typography.Body>
        </Flex.Item>
      </Flex>
    </Box>
  );
};

export { RoundInfo };
